module.exports = __webpack_public_path__ + "static/media/img-crop-icon.46186d28.svg";